import { ObservableModelNode } from "../observable";
import type { SpecsAutoFormFieldMetadataMap } from "../autoFormMetadata";
import { cloneValue, expectObject, readString, splitKnown } from "../utils";

export class LocalizedTextModel extends ObservableModelNode {
  static autoFormFields: SpecsAutoFormFieldMetadataMap = {
    fr: { label: "French", fieldType: "text" },
    en: { label: "English", fieldType: "text" },
    extra: { label: "Extra JSON", fieldType: "json", minRows: 4 },
  };

  fr!: string;
  en!: string;
  extra!: Record<string, unknown>;

  constructor(private context: string) {
    super();
    this.defineObservableValue("fr", "");
    this.defineObservableValue("en", "");
    this.defineObservableValue("extra", {});
  }

  restore(snapshot: unknown) {
    const source = expectObject(snapshot, this.context);
    this.fr = readString(source, "fr");
    this.en = readString(source, "en");
    this.extra = splitKnown(source, ["fr", "en"]);
    return this;
  }

  save() {
    return {
      ...cloneValue(this.extra),
      ...(this.fr ? { fr: this.fr } : {}),
      ...(this.en ? { en: this.en } : {}),
    };
  }
}
